<mat-form-field
  appearance="outline"
  class="dropdown-card-field"
  (click)="stop($event)"
  [attr.aria-label]="fieldAriaLabel || label"
>
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [placeholder]="placeholder"
    (focus)="openSelect()"
    (input)="onSearch(($any($event.target).value || ''))"
    (blur)="touched()"
    [disabled]="disabled"
  />

  <mat-select
    #select
    [disabled]="disabled"
    [multiple]="multiple"
    [value]="value"
    (selectionChange)="onSelection($event.value)"
    [compareWith]="compareWith"
    [panelClass]="panelClass"
  >
    <mat-select-trigger></mat-select-trigger>

    @for (item of filteredItems; track item) {
      <mat-option [value]="item">
        {{ displayWith(item) }}
      </mat-option>
    }
  </mat-select>

  @if (value.length) {
    <mat-chip-set>
      @for (v of value; let i = $index; track i) {
        <mat-chip-row (removed)="removeAt(i)">
          {{ displayWith(v) }}
          <button matChipRemove type="button" [disabled]="disabled">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-set>
  }
</mat-form-field>
